import { styled } from "@material-ui/core";

export const CheckboxWrapper = styled("div")({
  marginTop: 10,
  textAlign: 'center'
});
